import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { DragSortableDirective } from './directives/drag-sortable.directive';
import { SortableItemComponent } from './components/sortable-item/sortable-item.component';
import { SortableListComponent } from './components/sortable-list/sortable-list.component';
import { RgUtilsModule } from 'rg-utils';
// const COMPONENTS = [SortableItemComponent, SortableListComponent];
// const DIRECTIVES = [DragSortableDirective];
@NgModule({
    imports: [
        BrowserModule,
        CommonModule,
        RgUtilsModule
    ],
    declarations: [
        SortableListComponent,
        SortableItemComponent,
        DragSortableDirective
    ],
    exports: [
        SortableListComponent,
        SortableItemComponent,
        DragSortableDirective
    ]
})
export class SortableListModule { }
